import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { TicketProcessingStatus } from 'src/app/@core/constants';
import { Branch } from 'src/app/models/branch';
import { ColumnTable } from 'src/app/models/column-table';
import { Customer } from 'src/app/models/customer';
import { TicketFile } from 'src/app/models/equipment-registration-ticket-file';
import { Invoice } from 'src/app/models/invoice';
import { InvoiceLine } from 'src/app/models/invoice-line';
import { Paging } from 'src/app/models/page';
import { TicketType } from 'src/app/models/ticket-type';
import { BranchesService } from 'src/app/services/branches.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { ExceptionSolutionService } from 'src/app/services/exception-solution.service';
import { InvoiceService } from 'src/app/services/invoice.service';
import { ParamsService } from 'src/app/services/params.service';
import { TicketTypeService } from 'src/app/services/ticket-type.service';
import { TicketService } from 'src/app/services/ticket.service';

@Component({
  selector: 'app-ticket-delivery-creation',
  templateUrl: './ticket-delivery-creation.component.html',
  styleUrls: ['./ticket-delivery-creation.component.sass']
})
export class TicketDeliveryCreationComponent implements OnInit {

  searchForm: FormGroup;
  isTicketCreated: boolean = false;
  ticketHasErrors: boolean = false;
  ticketErrors: Array<string> = [];
  ticketNumber: string = "";
  ticketTypes: Array<TicketType> = [];
  invoiceLines: Paging<Array<InvoiceLine>> = new Paging([]);
  isLoaded: boolean = false;
  customerInfo: string = "";
  private _selectedDeliveryType: TicketType = new TicketType();

  set selectedDeliveryType(selectedDeliveryType: TicketType) {

    if (!this.branchesToLoadAllDestinationBranches.includes(this.configService.readSelectedBranchAndSalesOrg().branch.code) && selectedDeliveryType?.loadCurrentBranch) {
      this.branches = new Paging(this.branches.content.filter(f => f.code == this.configService.readSelectedBranchAndSalesOrg().branch.code));
    }
    else if (selectedDeliveryType?.useDestinationBranch) {
      this.branches = new Paging(this.allBranches.content);
    }
    this._selectedDeliveryType = selectedDeliveryType;
    this.selectedDestinationBranch = new Branch();
  }

  get selectedDeliveryType(): TicketType {
    return this._selectedDeliveryType;
  };

  selectedDestinationBranch: Branch = new Branch();
  requiredInstalation: boolean = false;
  invoice: Invoice = new Invoice();
  files: TicketFile[] = [];
  customer: Customer = new Customer();
  branches: Paging<Array<Branch>> = new Paging([]);
  allBranches: Paging<Array<Branch>> = new Paging([]);
  fullNumber: string = "";
  branchesToLoadAllDestinationBranches: string[] = [];
  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly invoiceService: InvoiceService,
    private readonly ticketService: TicketService,
    private readonly exceptionSolutionService: ExceptionSolutionService,
    private readonly configService: ConfigurationService,
    private readonly ticketTypeService: TicketTypeService,
    private readonly branchService: BranchesService,
    private readonly paramsService: ParamsService,
    private readonly router: Router
  ) {
    this.searchForm = this.formBuilder.group({
      searchCriteria: this.formBuilder.control(''),
    });

    this.fullNumber = router.getCurrentNavigation()?.extras.state?.fullNumber;
  }

  async ngOnInit(): Promise<void> {
    if (this.fullNumber && this.fullNumber.length > 0) {
      this.searchForm.get("searchCriteria")?.setValue(this.fullNumber.replace(/-/g, ""));
      this.handleSubmit();

    }
    this.ticketTypes = (await this.ticketTypeService.readTicketTypes(true).toPromise()).response.content;
    this.branches = (await this.branchService.readFilteredBranches({ page: 0, pageSize: 5000, value: { salesOrg: this.configService.readSelectedBranchAndSalesOrg().salesOrg.code } }).toPromise()).response;
    this.allBranches = new Paging(this.branches.content);
    this.branchesToLoadAllDestinationBranches = ((await this.paramsService.readParam("delivery-ticket-branch-load-all-destination-branches").toPromise()).response.value ?? "").split(',')


  }

  async handleSubmit() {
    this.clearInfo();
    let invoiceNumber = this.searchForm.get("searchCriteria")?.value;
    this.invoice = (await this.invoiceService.readInvoices({ page: 0, pageSize: 1, value: { fullNumber: invoiceNumber, salesOrg: this.configService.readSelectedBranchAndSalesOrg().salesOrg.code } }).toPromise()).response.content[0];
    if (!this.invoice) {
      this.exceptionSolutionService.showAlertWithSolution(`Tickets a Domicilio`, `Número de factura inválido ${invoiceNumber} </br> Error al ingresar el número de factura`, undefined, 'error');
      return;
    }
    if (!this.invoice.deliveryInvoiceLines.some(s => s.isForDelivery)) {
      this.exceptionSolutionService.showAlertWithSolution(`Tickets a Domicilio`, `Factura ${invoiceNumber} no tiene productos seleccionados con entrega a domicilio`, undefined, 'error');
      return;
    }
    this.isLoaded = true;
    this.customerInfo = `[${this.invoice.customerCode}]-${this.invoice.customerFullName}`;
    this.selectedDeliveryType = new TicketType();
    this.invoiceLines = new Paging(this.invoice.deliveryInvoiceLines.filter(f => f.isForDelivery));

    let ticket = (await this.ticketService.readTicketsByInvoiceCode(this.invoice.code, this.ticketTypes.map(m => m.code)).toPromise()).response.content[0]
    this.isTicketCreated = ticket != undefined;

    if (this.isTicketCreated) {
      this.ticketHasErrors = ticket.processingStatus == TicketProcessingStatus.FAILED;
      this.ticketErrors = ticket.processingMessages;
      this.ticketNumber = ticket.number;
      this.selectedDeliveryType = this.ticketTypes.find(f => f.code == ticket.type) ?? new TicketType();
      this.selectedDestinationBranch = this.allBranches.content.find(f => f.code == ticket.destinationBranch) ?? new Branch();
      this.requiredInstalation = ticket.reqInstallation;
    }
  }
  clearInfo() {
    this.isLoaded = false;
    this.isTicketCreated = false;
    this.ticketNumber = '';
    this.customerInfo = '';
    this.selectedDeliveryType = new TicketType();
    this.selectedDestinationBranch = new Branch();
    this.requiredInstalation = false;
  }

  getInvoiceLineHeaders(): Array<ColumnTable> {
    return [
      new ColumnTable("productCode", "Código"),
      new ColumnTable("productName", "Nombre"),
      new ColumnTable("serialNumber", "Serie"),
      new ColumnTable("quantity", "Cantidad")
    ];
  }

  onFilesChanged(files: TicketFile[]) {
    this.files = files;
  }

  async createTicket() {
    if (!this.selectedDeliveryType.code) {
      this.exceptionSolutionService.showAlertWithSolution(`Tickets a Domicilio`, `No se puede crear el ticket ya que tiene que escoger un tipo de entrega`, undefined, 'error');
      return;
    }
    if (this.selectedDeliveryType.useDestinationBranch && (!this.selectedDestinationBranch?.code)) {
      this.exceptionSolutionService.showAlertWithSolution(`Tickets a Domicilio`, `No se puede crear el ticket ya que requiere que se seleccione la tienda destino`, undefined, 'error');
      return;
    }
    await this.ticketService.createTicket(this.invoice.customerCode, this.selectedDeliveryType.description, "", this.invoiceLines.content[0].serialNumber, this.invoice.code, this.selectedDeliveryType.code, this.files, this.configService.readSelectedBranchAndSalesOrg().branch.code, this.configService.readSelectedBranchAndSalesOrg().salesOrg.code, this.requiredInstalation, this.selectedDestinationBranch.code).toPromise();
    await this.handleSubmit();
  }

}
